if(typeof __WEBPACK_EXTERNAL_MODULE__45__ === 'undefined') { var e = new Error("Cannot find module 'SiAntiPaySpider'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = __WEBPACK_EXTERNAL_MODULE__45__;